import _ from 'lodash';
import {
    getPrinterIdByPrintArea,
    printAreas
} from './modelUtils/orozcoTicketPrinterUtils';
import {guestFullName} from './modelUtils/guestUtils';
import {printSipAndFly} from './sipAndFlyPrinterApi';

const getAccessMethodName = (visit) => {
    const checkIn = visit?.checkIns?.[0];
    const method = checkIn?.loungeAccessMethod;

    if (!method)
        return '';

    return method.fullName || method.name || '';
};

const getSeatName = (visit) => {
    const seat = visit?.seats?.[0];

    if (!seat)
        return '';

    return seat.name ||
        seat?.loungeMapItem?.name ||
        seat?.config?.name ||
        '';
};

const getHostName = (visit) => {
    const attending = visit?.employeesAttendingVisit?.[0];

    return attending?.employee?.fullName || '';
};

const buildSipAndFlyPayload = ({
    visit,
    products,
    actualLounge,
    isCanceled
}) => ({
    order: {
        name: visit?.orozcoVisitOrder?.id || '',
        room: actualLounge?.name || '',
        guest: guestFullName(visit?.guest).trim(),
        host: getHostName(visit),
        seat: getSeatName(visit),
        folio: visit?.folio || visit?.folioNumber || '',
        access_method: getAccessMethodName(visit),
        date: new Date().toLocaleString('es-MX')
    },
    lines: products.map(product => {
        const modifierNames = (product?.orozcoProductModifiers || [])
            .map(modifier => modifier?.name)
            .filter(Boolean);

        const notes = [
            ...modifierNames,
            product?.notes,
            product?.data?.description,
            product?.canceledProductsComment
        ].filter(Boolean);

        return {
            name: product?.orozcoProduct?.name || 'Producto',
            qty: product?.quantity || 1,
            note: notes.join(' / ')
        };
    }),
    ...(isCanceled ? {is_canceled: true} : {})
});

/**
 * Imprime productos por área.
 *
 * Cocina / Bar / Dotcom / Servicios / Recepción:
 *   conserva api.orozcoPrints + ticketPrinter.
 *
 * SIP&FLY:
 *   único destino que utiliza Printer API HTTPS.
 */
export const printOperationalProducts = ({
    api,
    notifier,
    actualLounge,
    visit,
    products,
    isReprint = false,
    isCanceled = false
}) => {
    const prints = _.groupBy(
        products || [],
        'orozcoProduct.printArea'
    );

    const promises = [];

    _.each(prints, (productsToPrint, printArea) => {
        if (printArea === printAreas.sipandfly) {
            const payload = buildSipAndFlyPayload({
                visit,
                products: productsToPrint,
                actualLounge,
                isCanceled
            });

            const promise = printSipAndFly(actualLounge, payload)
                .then(() => {
                    notifier.success(
                        isCanceled
                            ? 'Cancelación enviada a SIP&FLY'
                            : 'Comanda enviada a SIP&FLY'
                    );
                })
                .catch(error => {
                    notifier.error(
                        error?.message ||
                        'No fue posible imprimir en SIP&FLY'
                    );
                });

            promises.push(promise);
            return;
        }

        const printerId = getPrinterIdByPrintArea(printArea);

        if (!printerId) {
            notifier.error(
                'La impresora de ' +
                printArea +
                ' no se encuentra configurada'
            );
            return;
        }

        const promise = api.orozcoPrints.create({
            params: {
                ticketPrinter: printerId,
                orozcoVisitOrderProducts:
                    _.map(productsToPrint, 'id'),
                ...(isReprint ? {isReprint: true} : {}),
                ...(isCanceled ? {isCanceled: true} : {})
            }
        }).then(() => {
            notifier.success(
                isCanceled
                    ? 'Cancelación impresa en ' + printArea
                    : 'Comanda impresa en ' + printArea
            );
        });

        promises.push(promise);
    });

    return Promise.all(promises);
};
